import React from 'react';
import { Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
	label: string;
	name: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	error?: boolean;
	helperText?: string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
	label,
	name,
	value,
	onChange,
	error,
	helperText,
}) => {
	const handleChange = (content: string) => {
		const event = {
			target: {
				name,
				value: content,
			},
		} as React.ChangeEvent<HTMLInputElement>;
		onChange(event);
	};

	return (
		<div style={{ marginBottom: '16px' }}>
			<Typography variant="body1" gutterBottom>
				{label}
			</Typography>
			<ReactQuill
				value={value}
				onChange={handleChange}
				style={{ height: '200px', marginBottom: '16px' }}
			/>
			{error && (
				<Typography color="error" variant="caption">
					{helperText}
				</Typography>
			)}
		</div>
	);
};

export default RichTextEditor;
